module.exports = __webpack_public_path__ + "static/media/zidio_logo.bd3a9abf.png";